import EditionFondateurDialog from "./EditionFondateurDialog";
import EditionPersonneDialog from "./EditionPersonneDialog";
import FondateurCard from "./FondateurCard";
import PersonneCard from "./PersonneCard";

export default {
    install(Vue) {
        Vue.component("a-edition-personne-dialog", EditionPersonneDialog);
        Vue.component("a-edition-fondateur-dialog", EditionFondateurDialog);
        Vue.component("a-fondateur-card", FondateurCard);
        Vue.component("a-personne-card", PersonneCard);
    }
}
